'use strict';
/**
 * @author Romatel
 */
import angular from 'angular';
import SupportTypeController from './controller/supportType';
import SupportTypeSelectController from './controller/supportTypeSelect';
import SupportTypeModalCreateController from './controller/supportTypeModalCreate';
import SupportTypeModalSelectController from './controller/supportTypeModalSelect';
import SupportTypeTable from './directive/supportTypeTable';
import SupportTypeService from './service/supportType';

export default angular.module('investmentProject.supportType', [])
    .controller('SupportTypeController', SupportTypeController)
    .controller('SupportTypeModalCreateController', SupportTypeModalCreateController)
    .controller('SupportTypeModalSelectController', SupportTypeModalSelectController)
    .controller('SupportTypeSelectController', SupportTypeSelectController)
    .directive('supportTypeTable', SupportTypeTable)
    .factory('SupportTypeService', SupportTypeService)
    .name;
